<template>
  <div class="kv">
    <div class="backgrounds" aria-hidden="true">
      <div class="backgrounds-left sp-dn"></div>
      <div class="backgrounds-right sp-dn"></div>
      <div class="backgrounds-sp pc-dn"></div>
    </div>
    <div class="inner">
      <div class="title">
        <div class="logo">
          <img
            src="../../../assets/images/_parts/mv/watashiplus.png"
            alt="watahis plus logo"
            width="200"
            height="64"
          />
        </div>
        <h1 class="main-title">
          <picture>
            <source
              media="(max-width: 599px)"
              srcset="../../../assets/images/_parts/mv/mv_title_sp.svg"
              width="240"
              height="119"
            />
            <img
              src="../../../assets/images/_parts/mv/mv_title_pc.svg"
              alt="Find My SKINCARE スキンケア商品検索チャート"
              width="560"
              height="92"
            />
          </picture>
        </h1>
      </div>
      <div class="visuals" aria-hidden="true">
        <div class="pc-visual sp-dn">
          <div class="pc-left">
            <img
              src="../../../assets/images/_parts/mv/mv_list_left_pc.svg"
              alt=""
              width="306"
              height="182"
            />
          </div>
          <div class="items">
            <div class="item">
              <img
                src="../../../assets/images/_parts/mv/mv_illustration_pc.svg"
                alt=""
                width="401"
                height="110"
              />
            </div>
            <div class="icon" ref="pcIcon" style="opacity: 0">
              <img
                src="../../../assets/images/_parts/mv/mv_search_pc.svg"
                alt=""
                width="114"
                height="125"
              />
            </div>
          </div>
          <div class="pc-right">
            <img
              src="../../../assets/images/_parts/mv/mv_list_right_pc.svg"
              alt=""
              width="306"
              height="182"
            />
          </div>
        </div>
        <div class="sp-visual pc-dn">
          <div class="sp-center">
            <img
              src="../../../assets/images/_parts/mv/mv_list_sp.svg"
              alt=""
              width="336"
              height="126"
            />
          </div>
          <div class="items">
            <div class="item">
              <img
                src="../../../assets/images/_parts/mv/mv_illustration_sp.svg"
                alt=""
                width="336"
                height="95"
              />
            </div>
            <div class="icon" ref="spIcon" style="opacity: 0">
              <img
                src="../../../assets/images/_parts/mv/mv_search_sp.svg"
                alt=""
                width="78"
                height="85"
              />
            </div>
          </div>
        </div>
      </div>
      <p class="desc">
        <picture>
          <source
            media="(max-width: 599px)"
            srcset="../../../assets/images/_parts/mv/mv_text_sp.svg"
            width="332"
            height="31"
          />
          <img
            src="../../../assets/images/_parts/mv/mv_text_pc.svg"
            alt="商品カテゴリーやブランドから商品を絞り込んで、複数のスキンケア商品からあなたにぴったりな商品を見つけよう。"
            width="480"
            height="43"
          />
        </picture>
      </p>
    </div>
  </div>
</template>
<script>
import velocity from "velocity-animate";

export default {
  name: "Kv",
  methods: {
    animateIcon() {
      const animatedIcons = [this.$refs.pcIcon, this.$refs.spIcon];
      animatedIcons.forEach(async (icon) => {
        // initialize
        velocity(icon, "stop");
        await velocity(icon, { scale: 0.2, opacity: 1 }, { duration: 0 });

        // appear-animation (elastic)
        await velocity(
          icon,
          { scale: 1 },
          { duration: 1800, easing: "customEaseElasticOut" } // customEaseElasticOutは全体で使用できるようにmain.jsで設定済み
        );
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.animateIcon();
    });
  },
};
</script>
<style lang="scss" scoped>
.kv {
  width: 100%;
  position: relative;

  .backgrounds {
    position: absolute;
    top: 39px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    height: 156px;
    /* min-width: 1260px; */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    pointer-events: none;
  }

  .backgrounds-left {
    display: block;
    position: relative;
    right: 330px;
    width: 100%;
    min-width: 426px;
    height: 100%;
    background: url("../../../assets/images/_parts/mv/mv_bg_left_pc.svg")
      repeat-x right/contain;
  }

  .backgrounds-right {
    display: block;
    position: relative;
    left: 330px;
    width: 100%;
    min-width: 426px;
    height: 100%;
    background: url("../../../assets/images/_parts/mv/mv_bg_right_pc.svg")
      repeat-x left/contain;
  }

  .inner {
    width: 100%;
    max-width: 960px;
    padding: 38px 0px;
    margin: 0 auto;
  }

  .title {
    position: relative;
    left: 14px;
  }

  .logo {
    width: 100px;
    margin: 0 auto;
  }

  .main-title {
    margin: 30px auto 0;
    width: 560px;
  }

  .visuals {
    .pc-visual {
      position: relative;
      margin-top: 60px;

      .pc-left,
      .pc-right {
        width: 310px;
        position: absolute;
      }

      .pc-left {
        left: 0;
        top: -20px;
      }
      .pc-right {
        right: 0;
        top: -20px;
      }

      .items {
        position: relative;
        margin: 0 auto 0;
        width: 400px;
      }

      .item {
        width: 100%;
      }

      .icon {
        position: absolute;
        right: 24px;
        top: 16px;

        width: 115px;
      }
    }
  }
  .desc {
    width: 480px;
    margin: 40px auto 0;
  }

  @include media() {
    .backgrounds {
      position: absolute;
      top: vw(20);
      display: block;
      height: auto;
    }

    .backgrounds-sp {
      display: block;
      position: relative;
      width: vw(375);
      height: vw(145);
      min-width: auto;
      background: url("../../../assets/images/_parts/mv/mv_bg_sp.svg") no-repeat
        center/contain;
    }

    .inner {
      max-width: none;
      padding: vw(85) 0px vw(30);
    }

    .title {
      left: 0;
    }

    .logo {
      width: vw(85);
    }

    .main-title {
      margin: vw(20) auto 0;
      width: vw(240);
    }

    .visuals {
      .sp-visual {
        width: 100%;
        margin-top: vw(30);
      }
      .sp-center {
        width: vw(340);
        margin: 0 auto;
      }

      .items {
        position: relative;
        width: vw(340);
        margin: vw(-45) auto 0;
      }

      .item {
        width: 100%;
      }

      .icon {
        position: absolute;
        width: vw(78);
        bottom: vw(-18);
        right: vw(48);
      }
    }
    .desc {
      width: vw(340);
      margin: vw(30) auto 0;
    }
  }
}
</style>
